import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { setContext } from '@apollo/client/link/context';
// import gql from 'graphql-tag';

const cache = new InMemoryCache();

const link = new HttpLink({ uri: 'https://resttour.an.r.appspot.com/graphql' });

const authLink = setContext((_, { headers }) => {  
  const token = localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      authorization: token ? token : ``,
    }
  }
});

export const client = new ApolloClient({ cache, link: authLink.concat(link), });

window.__APOLLO_CLIENT__ = client;

// 테스트 코드 1
// (async function() {
//   const { loading, error, data} = await __APOLLO_CLIENT__.query({
//       query: gql`
//         query {
//           restAreaList(offset:5 limit: 10){
//             restAreas {
//               name
//               id
//               modifiedAt
//               createdAt
//               foods {
//                 best
//                 name
//                 price
//                 premium
//                 description
//               }
//             }
//             count
//           }
//         }
//       `,
//   });
//   console.log("loading:", loading);
//   console.log("error:", error);
//   console.log("data:", data);
// })();

// 테스트 코드 2
// class ConnectedElement extends ApolloQuery {
  // query = gql`
  // query {
  //   restAreaList(offset:5 limit: 10){
  //     restAreas {
  //       name
  //       id
  //       modifiedAt
  //       createdAt
  //       foods {
  //         best
  //         name
  //         price
  //         premium
  //         description
  //       }
  //     }
  //     count
  //   }
  // }
  // `;

//   render() {
//     const { data, error, loading } = this;
//     console.log(data);
//     return (
//         loading ? html`
//           <what-spin></what-spin>`
//       : error ? html`
//           <h1>😢 Such Sad, Very Error! 😰</h1>
//           <div>${error ? error.message : 'Unknown Error'}</div>`
//       : html`
//           <div>test</div>
//         `
//     );
//    }
// };

// customElements.define('connected-element', ConnectedElement)
